export const LOGIN_DELIVERY_USER = "LOGIN_DELIVERY_USER";
export const REGISTER_DELIVERY_USER = "REGISTER_DELIVERY_USER";
export const REGISTER_UPDATE_USER = "REGISTER_UPDATE_USER"
export const LOGOUT_DELIVERY_USER = "LOGOUT_DELIVERY_USER";
export const UPDATE_DELIVERY_USER_INFO = "UPDATE_DELIVERY_USER_INFO";
export const UPDATE_DELIVERY_ORDER_HISTORY = "UPDATE_DELIVERY_ORDER_HISTORY";
export const LEADER_BOARD = "LEADER_BOARD";
export const REQUEST_PAYOUT = "REQUEST_PAYOUT";
export const VIEW_PAYOUT = "VIEW_PAYOUT";
